import { apiClientChatting } from '@/utils/axios'

import type { Audio, EditAudioRequestOptions } from '../types'

const getAudios = (creatorId: number): Promise<Audio[]> => {
  return apiClientChatting
    .get(`/chat-audio/${creatorId}`)
    .then((res) => res.data)
}

const editAudio = ({
  creatorId,
  id,
  ...audio
}: EditAudioRequestOptions): Promise<Audio> => {
  return apiClientChatting
    .put(`/chat-audio/${creatorId}/${id}`, audio)
    .then((res) => res.data)
}

const deleteAudio = ({
  id,
  creatorId,
}: {
  creatorId: number
  id: string
}): Promise<void> => {
  return apiClientChatting
    .delete(`/chat-audio/${creatorId}/${id}`)
    .then((res) => res.data)
}

const getAudioFile = ({
  id,
  creatorId,
}: {
  creatorId: number
  id: string
}): Promise<string> => {
  return apiClientChatting
    .get(`/chat-audio/${creatorId}/${id}`)
    .then((res) => res.data)
}

export const audioService = {
  getAudios,
  editAudio,
  deleteAudio,
  getAudioFile,
}
